const prefix = '/api/materiality-assessment/questions-list';

export const QUESTIONS_LIST_TAG = `${prefix}`;

export default QUESTIONS_LIST_TAG;
